import React, { useEffect } from 'react';
import ReactDatePicker from 'react-datepicker';
import * as yup from 'yup';
import moment from 'moment';
import Select from 'react-select';
import { useFormik } from 'formik';
import styled from 'styled-components';
import { Modal } from 'antd';
import { ThemeProps } from '../../../../genericComponents/globalStyles';
import headerBackground from '../../../../../assets/images/headerBackgroundYellow.png';

const schema = yup.object().shape({
  work_title: yup
    .string()
    .required()
    .max(200, 'Title of work must be at most 200 characters'),
  research_type: yup
    .array()
    .min(1, 'Pick at least 1 tags')
    .of(
      yup.object().shape({
        label: yup.string().required(),
        value: yup.string().required(),
      }),
    ),
  primary_investigator: yup
    .string()
    .required()
    .max(200, 'Primary investigator must be at most 200 characters'),
  link: yup
    .string()
    .required()
    .matches(
      /^((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      'Enter correct url!',
    ),
  journal: yup
    .string()
    .required()
    .max(200, 'Journal must be at most 200 characters'),
  event_date: yup.string().required('Event date is a required field'),
  city: yup
    .string()
    .required()
    .max(200, 'Event address must be at most 200 characters'),
  author: yup
    .string()
    .required()
    .max(200, 'Author must be at most 200 characters'),
  event_name: yup
    .string()
    .required()
    .max(200, 'Event name must be at most 200 characters'),
});

const initialValues = {
  author: '',
  city: '',
  event_date: new Date(),
  event_name: '',
  journal: '',
  link: '',
  show_link: false,
  primary_investigator: '',
  research_type: [],
  work_title: '',
};

const researchTypeOptions = [
  { value: 'Publication', label: 'Publication' },
  { value: 'Presentation', label: 'Presentation' },
  { value: 'Abstract', label: 'Abstract' },
  { value: 'Poster', label: 'Poster' },
];

export default function ResearchModal(props) {
  const { isShow, onHide, addNewResearch, editResearch, deleteResearch, editValues } = props;

  useEffect(() => {
    if (isShow) {
      const pre_event_date = editValues?.event_date ? moment(editValues?.event_date || '', 'DD/MM/YYYY').format() : moment().format()
      setFieldValue("work_title", editValues?.work_title || '')
      setFieldValue("event_date", new Date(pre_event_date))
      setFieldValue("event_name", editValues?.event_name || '')
      setFieldValue("work_title", editValues?.work_title || '')
      setFieldValue("city", editValues?.city || '')
      setFieldValue("primary_investigator", editValues?.primary_investigator || '')
      setFieldValue("author", editValues?.author || '')
      setFieldValue("journal", editValues?.journal || '')
      setFieldValue("link", editValues?.link || '')
      setFieldValue("show_link", editValues?.show_link || false)
    }
  }, [isShow])

  const {
    errors,
    handleChange,
    handleSubmit,
    values,
    setFieldValue,
    touched,
    setFieldTouched,
  } = useFormik({
    initialValues: { ...initialValues },
    validationSchema: schema,
    onSubmit: onSubmit,
  });

  function onSubmit(values) {

    let newResearchType = "";
    values.research_type.forEach(item => {
      newResearchType = `${newResearchType},${item.value}`;
    });
    const newResearch = {
      id: '',
      subcollectionId: '',
      author: values.author,
      event_date: moment(values.event_date).format('DD/MM/YYYY').toString(),
      event_name: values.event_name,
      journal: values.journal,
      link: values.link,
      primary_investigator: values.primary_investigator,
      research_type: newResearchType,
      show_link: values.show_link,
      work_title: values.work_title,
      city: values.city,
      subcollectionName: "researchs",
    };
    if (editValues) {
      newResearch.subcollectionId = editValues.id;
      newResearch.id = editValues.id;
      editResearch(newResearch);
    } else {
      addNewResearch(newResearch);
    }
  }

  function onDelete(e) {
    e.preventDefault();
    deleteResearch({
      subcollectionId: editValues.id,
      subcollectionName: 'researchs'
    });
  }

  return (
    <Modal footer={null} visible={isShow} width={900} onCancel={onHide}>
      <FormContainer onSubmit={handleSubmit}>
        <ModalHeader>
          <Titles fonstSize={"2em"}>{editValues ? 'Edit Research Experience' : 'Add Research Experience'}</Titles>
          <LineBottomYellow />
        </ModalHeader>

        <Container>
          <Row100>
            <RowWithVariable width={"60%"}>
              <Titles>Title</Titles>
              <SelectWrapper
                name="research_type"
                isMulti={true}
                value={values.research_type}
                onChange={(opt, e) => {
                  if (opt !== null) {
                    setFieldValue('research_type', opt);
                  }
                }}
                options={researchTypeOptions}
              />
              {touched.research_type && errors.research_type && (
                <ErrorText>{errors.research_type}</ErrorText>
              )}
            </RowWithVariable>
            <RowWithVariable width={"38%"}>
              <Titles>Event Date</Titles>
              <ReactDatePickerWraper
                name="event_date"
                className="form-control"
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
                placeholderText="MMM DD,yyyy"
                onChange={e => {
                  setFieldValue('event_date', e);
                }}
                selected={values.event_date}
              />
              {touched.event_date && errors.event_date && (
                <ErrorText>{errors.event_date}</ErrorText>
              )}
            </RowWithVariable>
          </Row100>
          <Divider />
          <Titles>Event name</Titles>
          <Input
            name="event_name"
            type="text"
            className="form-control"
            placeholder="Event name"
            value={values.event_name}
            onChange={handleChange}
          />
          {touched.event_name && errors.event_name && (
            <ErrorText>{errors.event_name}</ErrorText>
          )}
          <Divider />
          <Titles>Title of work</Titles>
          <Input
            name="work_title"
            type="text"
            className="form-control"
            placeholder="Title of work"
            value={values.work_title}
            onChange={handleChange}
          />
          {touched.work_title && errors.work_title && (
            <ErrorText>{errors.work_title}</ErrorText>
          )}
          <Divider />
          <Titles>City, State</Titles>
          <Input
            name="city"
            className="form-control"
            placeholder="City, State"
            value={values.city}
            onChange={handleChange}
          />
          {touched.city && errors.city && (
            <ErrorText>{errors.city}</ErrorText>
          )}
          <Divider />
          <Titles>Primary investigator</Titles>
          <Input
            name="primary_investigator"
            className="form-control"
            placeholder="Name"
            value={values.primary_investigator}
            onChange={handleChange}
          />
          {touched.primary_investigator &&
            errors.primary_investigator && (
              <ErrorText>{errors.primary_investigator}</ErrorText>
            )}
          <Divider />
          <Titles>Author</Titles>
          <Input
            name="author"
            className="form-control"
            placeholder="Name"
            value={values.author}
            onChange={handleChange}
          />
          {touched.author && errors.author && (
            <ErrorText>{errors.author}</ErrorText>
          )}
          <Divider />
          <Titles>Journal</Titles>
          <Input
            name="journal"
            className="form-control"
            placeholder="Journal"
            value={values.journal}
            onChange={handleChange}
          />
          {touched.journal && errors.journal && (
            <ErrorText>{errors.journal}</ErrorText>
          )}
          <Divider />
          <Row100>
            <Titles>Link</Titles>
            <label>
              <input
                onChange={handleChange}
                type="checkbox"
                name="show_link"
                value={values.show_link}
              />
              {' Show link'}
            </label>
          </Row100>
          <Input
            name="link"
            className="form-control"
            placeholder="Link"
            value={values.link}
            onChange={handleChange}
          />
          {touched.link && errors.link && (
            <ErrorText>{errors.link}</ErrorText>
          )}
          <Divider />
          <Row100>
            {editValues ? (
              <>
                <Button type="button" onClick={onDelete}>Delete</Button>
                <Button
                  type="submit"
                  color="#FFF"
                  backgroundColor={ThemeProps.color.darkBlue}
                >
                  Save
                </Button>
              </>
            ) :
              <>
                <Button onClick={onHide} color={ThemeProps.color.darkBlue} >Cancel</Button>
                <Button
                  type="submit"
                  color="#FFF"
                  backgroundColor={ThemeProps.color.darkBlue}
                >
                  Save
                </Button>
              </>
            }
          </Row100>
        </Container>
      </FormContainer>
    </Modal>
  );
};

const SelectWrapper = styled(Select)`
  margin-top: 8px;
`;
const ModalHeader = styled.div`
  width: 100%;
  padding: 20px 16%;
  margin-bottom: 24px;
  background-image: url(${headerBackground});
  background-position-x: -50px;
  background-color: #fefefe;
  border-bottom: 1px solid #ddd;
`;
const Container = styled.div`
  width: 100%;
  padding: 16px 16%;
`;
const LineBottomYellow = styled.div`
  width: 100%;
  border-bottom: 3px solid ${ThemeProps.color.gabaYellow};
  margin: 12px 0;
`;
const Divider = styled.div`
  width: 100%;
  border-bottom: 3px solid #eee;
  margin: 16px 0;
`;
const Input = styled.input`
  width: 100%;
  margin: 8px 0 0 0;
  font-size: 1.3em;
  padding: 10px 12px;
  border-radius: 4px;
  outline-color: #aaa;
  background-color: #fbfbfb;
  border: 2.5px solid #ddd;
`;
const Titles = styled.label`
  font-size: ${p => p.fonstSize || "1.4em"};
`;
const FormContainer = styled.form`
  display:flex;
  flex-direction: column;
  width: 100%;
`;
const ReactDatePickerWraper = styled(ReactDatePicker)`
  width: 100%;
  margin: 8px 0;
  border: 1px solid #ccc;
  font-size: 1.3em;
  padding: 8px 12px;
  background-color: #fbfbfb;
  outline-color: #aaa;
  border-radius: 4px;
`;
const Row100 = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const RowWithVariable = styled.div`
  width: ${p=>p.width};

`;
const Button = styled.button`
  width: 49%;
  padding: 14px 20px;
  font-size: 1.3em;
  margin-top: 8px;
  border-radius: 6px;
  background-color: ${p => p.backgroundColor};
  color: ${p => p.color};
  border: none;
  outline: none;
`;
const ErrorText = styled.p`
  color: #F00;
  margin: 8px 0;
`;